import React, { useState } from 'react';

const BudgetCalculator = ({ clientCountry = 'México' }) => {
  const [dailyBudget, setDailyBudget] = useState('');
  const [monthlyBudget, setMonthlyBudget] = useState(0);
  const [monthlyBudgetWithIVA, setMonthlyBudgetWithIVA] = useState(0);

  const IVA_RATE = 0.16;
  const DAYS_IN_MONTH = 30.4;

  const calculateBudget = () => {
    const daily = parseFloat(dailyBudget);
    if (isNaN(daily) || daily <= 0) {
      setMonthlyBudget(0);
      setMonthlyBudgetWithIVA(0);
      return;
    }

    const monthly = daily * DAYS_IN_MONTH;
    setMonthlyBudget(monthly);

    if (clientCountry.toLowerCase() === 'méxico') {
      setMonthlyBudgetWithIVA(monthly * (1 + IVA_RATE));
    } else {
      setMonthlyBudgetWithIVA(monthly); // No IVA for other countries
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mt-6">
      <h3 className="text-lg font-semibold text-[#0061A8] mb-4">Calculadora de Presupuesto Mensual</h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-[#63666A]">Presupuesto Diario</label>
          <input
            type="number"
            value={dailyBudget}
            onChange={(e) => setDailyBudget(e.target.value)}
            onBlur={calculateBudget}
            onKeyPress={(e) => { if (e.key === 'Enter') calculateBudget(); }}
            placeholder="Ej. 1000"
            className="mt-1 block w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#0061A8] focus:border-[#0061A8]"
          />
        </div>
        <div>
          <p className="text-sm font-medium text-[#63666A]">Presupuesto Mensual (sin IVA)</p>
          <p className="text-lg font-bold text-[#0061A8]">${monthlyBudget.toFixed(2)}</p>
        </div>
        <div>
          <p className="text-sm font-medium text-[#63666A]">Presupuesto Mensual (con IVA {clientCountry.toLowerCase() === 'méxico' ? '16%' : '0%'})</p>
          <p className="text-lg font-bold text-[#0061A8]">${monthlyBudgetWithIVA.toFixed(2)}</p>
        </div>
        {clientCountry.toLowerCase() !== 'méxico' && (
          <p className="text-xs text-[#63666A]">El IVA solo se aplica a clientes de México.</p>
        )}
      </div>
    </div>
  );
};

export default BudgetCalculator;